import { useEffect } from 'react';

/**
 * Custom hook that listens for clicks outside of the passed ref
 * @param {React.Ref} ref - The ref of the component to detect outside clicks.
 * @param {Function} callback - The function to call when a click outside is detected.
 */
const useClickOutside = (ref, callback) => {
  useEffect(() => {
    const handleClickOutside = (event) => {
      // If the click is outside of the container, execute the callback
      if (ref.current && !ref.current.contains(event.target)) {
        callback();
      }
    };

    // Add the event listener
    document.addEventListener('mousedown', handleClickOutside);

    // Cleanup the event listener on component unmount or ref change
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, callback]); // Dependency array includes ref and callback
};

export default useClickOutside;